<footer
    class="footer mt-auto xl:ps-[15rem] font-normal font-inter bg-white text-defaultsize leading-normal text-[0.813] shadow-[0_0_0.4rem_rgba(0,0,0,0.1)] dark:bg-bodybg py-8 mt-10 text-center">
    <div class="container">
        <span class="text-gray dark:text-defaulttextcolor/50">
            Copyright ©
            <span id="year">{{ currentYear }}</span>
            <a href="https://nunciaturaapostolica.org.br/" target="_blank" rel="noopener noreferrer" class="text-defaulttextcolor font-semibold dark:text-defaulttextcolor">
                Nunciatura Apostólica no Brasil.
            </a>

            Todos os direitos reservados. <br>

            <span class="text-[8pt]">
                Desenvolvido por
                <a href="https://onefactory.com.br" target="_blank" rel="noopener noreferrer" class="text-defaulttextcolor font-semibold dark:text-defaulttextcolor">
                    OneFactory.
                </a>
            </span>
        </span>
    </div>
</footer>